import { MutationCache, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { ApiError } from "./api/client";
import { App } from "./App";
import { DialogProvider, globalToast } from "./components/Dialogs";
import "./styles/theme.css";
import "./styles/base.css";
import "./styles/layout.css";
import "./styles/board.css";
import "./styles/task.css";
import "./styles/timeline.css";
import "./styles/settings.css";
import "./styles/monitor.css";
import "./styles/richdiff.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 10_000,
      retry: (count, err) => !(err instanceof ApiError && err.status >= 400 && err.status < 500) && count < 2,
    },
  },
  mutationCache: new MutationCache({
    onError: (err, _vars, _ctx, mutation) => {
      // Mutations that render their own error inline set meta.inlineError.
      if (mutation.meta?.inlineError) return;
      if (err instanceof ApiError && err.status === 401) return;
      globalToast.current?.(err instanceof Error ? err.message : String(err));
    },
  }),
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <DialogProvider>
          <App />
        </DialogProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
